/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import moment from 'moment';
import { isEmpty } from '../helper/is-empty.helper';

export function validateDate(value: any): boolean {
  // TODO: specify formats (include UTC, ISO, locale)
  return isEmpty(value) || moment(value, null, true).isValid();
}
